import React, { useRef, useState } from 'react'
import VideoGallerysDisplay from '../../Movie/GalleryVideos/VideoGallerysDisplay'
import VideoPlatform from '../../Movie/GalleryVideos/VideoPlatform'
import PreViewVideo from '../../Movie/GalleryVideos/PreViewVideo'

const PerformanceVideos = props => {
  const {
    GalleryVideos,
    personalAndBackGroundInfo,
    setPersonalAndBackGroundInfo,
    setChangesMade,
    // inputData,
    // sendinputdata,
    // disableInput,
    index,
    question,
  } = props
  const [previewVideo, setPreviewVideo] = useState({
    path: '',
    title: '',
    videoPlatform: '',
  })

  const dragItem = useRef()
  const dragOverItem = useRef()

  const dragStart = (e, position) => {
    dragItem.current = position
  }

  const dragEnter = (e, position) => {
    dragOverItem.current = position
  }

  const drop = () => {
    const GalleryVideosImages = [...GalleryVideos]
    const dragItemContent = GalleryVideosImages[dragItem.current]
    GalleryVideosImages.splice(dragItem.current, 1)
    GalleryVideosImages.splice(dragOverItem.current, 0, dragItemContent)
    const inputDataCopy = [...personalAndBackGroundInfo]
    inputDataCopy[index].answerItems_En = GalleryVideosImages
    setPersonalAndBackGroundInfo(inputDataCopy)
    // inputDataCopy.GalleryVideos = GalleryVideosImages
    // sendinputdata(inputDataCopy)
  }

  const handleChange = e => {
    const { name, value } = e.target
    setPreviewVideo({
      ...previewVideo,
      [name]: value,
    })
  }

  const removeVideo = removeIndex => {
    const inputDataCopy = [...personalAndBackGroundInfo]
    const GalleryVideosImages = [...GalleryVideos].filter((item, i) => i !== removeIndex)
    inputDataCopy[index].answerItems_En = GalleryVideosImages
    // console.log(inputDataCopy, 'inputDataCopy===')
    setPersonalAndBackGroundInfo(inputDataCopy)
    // const inputDataCopy = [...personalAndBackGroundInfo]
    // inputDataCopy[index].answerItems_En = GalleryVideosTemp
    // setPersonalAndBackGroundInfo(inputDataCopy)
    setChangesMade(true)
  }

  const EditVideo = editIndex => {
    const inputDataCopy = [...personalAndBackGroundInfo]
    const GalleryVideosTemp = [...GalleryVideos]
    const EditValue = GalleryVideosTemp.splice(editIndex, 1)
    setPreviewVideo(EditValue[0])
    // inputDataCopy.GalleryVideos = GalleryVideosTemp
    // sendinputdata(inputDataCopy)
    inputDataCopy[index].answerItems_En = GalleryVideosTemp
    setPersonalAndBackGroundInfo(inputDataCopy)
  }

  const handleSubmit = () => {
    const GalleryVideosTemp = [...GalleryVideos]

    if (previewVideo.videoPlatform === 'youtube') {
      let path = ''
      let thumbnail = ''
      if (previewVideo.path.includes('https://www.youtube.com/') === false) {
        const url = previewVideo.path
        path = url
      } else if (previewVideo.path.includes('embed')) {
        const url = previewVideo.path
        const videoId = url.split('embed/')[1]
        const ampersandPosition = videoId.indexOf('&')
        if (ampersandPosition > -1) {
          path = `https://www.youtube.com/embed/${videoId.substring(0, ampersandPosition)}`
          thumbnail = `https://img.youtube.com/vi/${videoId.substring(
            0,
            ampersandPosition,
          )}/mqdefault.jpg`
        } else {
          path = `https://www.youtube.com/embed/${videoId}`
          thumbnail = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`
        }
      } else {
        const url = previewVideo.path
        const videoId = url.split('v=')[1]
        const ampersandPosition = videoId.indexOf('&')
        if (ampersandPosition > -1) {
          path = `https://www.youtube.com/embed/${videoId.substring(0, ampersandPosition)}`
          thumbnail = `https://img.youtube.com/vi/${videoId.substring(
            0,
            ampersandPosition,
          )}/mqdefault.jpg`
        } else {
          path = `https://www.youtube.com/embed/${videoId}`
          thumbnail = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`
        }
      }

      GalleryVideosTemp.push({
        path,
        thumbnail,
        videoPlatform: previewVideo.videoPlatform,
        title: previewVideo.title,
      })
      setChangesMade(true)
    } else {
      GalleryVideosTemp.push(previewVideo)
      setChangesMade(true)
    }

    const inputDataCopy = [...personalAndBackGroundInfo]
    inputDataCopy[index].answerItems_En = GalleryVideosTemp
    setPersonalAndBackGroundInfo(inputDataCopy)
    // inputDataCopy.GalleryVideos = GalleryVideosTemp
    // sendinputdata(inputDataCopy)
    setPreviewVideo({
      path: '',
      title: '',
      videoPlatform: '',
    })
  }

  return (
    <div>
      <div>
        <label>{question}</label>
        <VideoGallerysDisplay
          GalleryVideos={GalleryVideos}
          dragEnter={dragEnter}
          dragStart={dragStart}
          drop={drop}
          removeVideo={removeVideo}
        //   disableInput={disableInput}
          EditVideo={EditVideo}
        />
      </div>

      <div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '100px' }}>
          <div>
            <label htmlFor='path'>Path:</label>
            <input
              type='text'
              id='path'
              name='path'
              className='form-control'
              value={previewVideo.path}
              onChange={event => handleChange(event)}
            />
          </div>
          <div>
            <label htmlFor='title'>Title:</label>
            <input
              type='text'
              id='title'
              name='title'
              className='form-control'
              value={previewVideo.title}
              onChange={event => handleChange(event)}
            />
          </div>
        </div>
        <VideoPlatform previewVideo={previewVideo} handleChange={handleChange} />
        <PreViewVideo previewVideo={previewVideo} handleSubmit={handleSubmit} />
      </div>
    </div>
  )
}

export default PerformanceVideos
